module.exports = __webpack_public_path__ + "img/jin3.d2d64ff1.png";